<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="navbar">
    <img src="../../assets/image/SongPaMainLogo.png" class="imgText" @click="$router.push('/')">

    <div class="container-template">
      <div class="container-main">
        <p class="container-main-name">스마트 주차관리 시스템</p>
        <p class="container-main-name-en">SMART PARKING LOT MANAGEMENT SYSTEM</p>

      </div>

      <!-- <el-button type="primary" class="pageBtn">로그인 페이지</el-button> -->
      <div class="right-menu">

        <!-- <el-button class="userPage" @click="routerUserPage">사용자페이지</el-button> -->

        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">

          <div class="avatar-wrapper">

            <div class="profile-info">

              <div class="name">{{ name }}</div>
              <!-- <div class="dateTime">사용 가능한 시간: <span>2022-05-10 20:00</span></div> -->
            </div>
            <div class="user-avatar">A</div>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">

            <el-dropdown-item @click.native="logout">
              <span style="display:block;">로그아웃</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  data() {
    return {
      name: localStorage.getItem('accessName')
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ])
  },
  methods: {
    // toggleSideBar() {
    //   this.$store.dispatch('app/toggleSideBar')
    // },
    async logout() {
      // await this.$store.dispatch('user/logout')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('accessName')
      this.$router.push(`/login`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  // margin-left: 211px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  z-index: 1000;

  .container-template {
    display: flex;
    height: 100%;
    .container-main {
      width: 100%;
      margin-left: 30px;

      .container-main-name {
        font: 20px/29px NotoSansKR-Medium;
        margin: 0;
        margin-top: 0.2%;
      }

      .container-main-name-en {
        font: 11px/16px NotoSansKR;
        margin: 0;
      }
    }
    .right-menu {
      float: right;
      height: 100%;

      .userPage {
        position: absolute;
        right: 15%;
        top: 5px;
        height: 40px;
        width: 125px;
        background: #0070c0;
        // font-family: NotoSansKR-Medium;
        // font-size: 15px;
        border-radius: 8px;
        color: #fff;
      }

      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }

      .avatar-container {
        margin-right: 28px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;
          display: flex;
          align-items: center;
          .profile-info {
            width: 230px;
            font-family: NotoSansKR-Medium;
            font-size: 12px;
            margin-right: 10px;
            text-align: end;

            .dateTime {
              margin-top: 5px;
            }
          }
          .user-avatar {
            cursor: pointer;
            font-family: NotoSansKR-Regular;
            font-size: 20px;
            letter-spacing: 1px;
            color: #fff;
            text-align: center;
            line-height: 35px;
            width: 38px;
            height: 38px;
            background: #0070c0;
            border-radius: 50%;
          }

          .el-icon-caret-bottom {
            margin-top: 20px;
            display: none;
          }
        }
      }
    }
  }

  .imgText {
    cursor: pointer;
    float: left;
    width: 210px;
    // margin-top: 10px;
    margin-left: 15px;
  }

}
</style>
